export default __webpack_public_path__ + "static/media/icon-practice-active.d7e5914d.svg";